// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"lY-z","sponsoredTooltipWrapper":"mY-z","sponsoredTooltip":"nY-z","newCard":"oY-z"};